import { getLocale } from '@pb/utils'
import { createBrowserHistory } from 'history'

const BASE_ROUTE = `/${getLocale()}`

const history = createBrowserHistory({
  basename: BASE_ROUTE,
})

export default history
